import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || "https://productivitytool-365bd-688734725593.asia-southeast1.run.app/api";

const WindowsIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M0 0h11.4v11.4H0zM12.6 0H24v11.4H12.6zM0 12.6h11.4V24H0zM12.6 12.6H24V24H12.6z" />
  </svg>
);

// Tux, from Simple Icons (CC0)
const LinuxIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.132 1.884 1.071.771-.06 1.592-.536 2.257-1.306.631-.765 1.683-1.084 2.378-1.503.348-.199.629-.469.649-.853.023-.4-.2-.811-.714-1.376v-.097l-.003-.003c-.17-.2-.25-.535-.338-.926-.085-.401-.182-.786-.492-1.046h-.003c-.059-.054-.123-.067-.188-.135a.357.357 0 00-.19-.064c.431-1.278.264-2.55-.173-3.694-.533-1.41-1.465-2.638-2.175-3.483-.796-1.005-1.576-1.957-1.56-3.368.026-2.152.236-6.133-3.544-6.139zm.529 3.405h.013c.213 0 .396.062.584.198.19.135.33.332.438.533.105.259.158.459.166.724 0-.02.006-.04.006-.06v.105a.086.086 0 01-.004-.021l-.004-.024a1.807 1.807 0 01-.15.706.953.953 0 01-.213.335.71.71 0 00-.088-.042c-.104-.045-.198-.064-.284-.133a1.312 1.312 0 00-.22-.066c.05-.06.146-.133.183-.198.053-.128.082-.264.088-.402v-.02a1.21 1.21 0 00-.061-.4c-.045-.134-.101-.2-.183-.333-.084-.066-.167-.132-.267-.132h-.016c-.093 0-.176.03-.262.132a.8.8 0 00-.205.334 1.18 1.18 0 00-.09.4v.019c.002.089.008.179.02.267-.193-.067-.438-.135-.607-.202a1.635 1.635 0 01-.018-.2v-.02a1.772 1.772 0 01.15-.768c.082-.22.232-.406.43-.533a.985.985 0 01.594-.2zm-2.962.059h.036c.142 0 .27.048.399.135.146.129.264.288.344.465.09.199.14.4.153.667v.004c.007.134.006.2-.002.266v.08c-.03.007-.056.018-.083.024-.152.055-.274.135-.393.2.012-.09.013-.18.003-.267v-.015c-.012-.133-.04-.2-.082-.333a.613.613 0 00-.166-.267.248.248 0 00-.183-.064h-.021c-.071.006-.13.04-.186.132a.552.552 0 00-.12.27.944.944 0 00-.023.33v.015c.012.135.037.2.08.334.046.134.098.2.166.268.01.009.02.018.034.024-.07.057-.117.07-.176.136a.304.304 0 01-.131.068 2.62 2.62 0 01-.275-.402 1.772 1.772 0 01-.155-.667 1.759 1.759 0 01.08-.668 1.43 1.43 0 01.283-.535c.128-.133.26-.2.418-.2zm1.37 1.706c.332 0 .733.065 1.216.399.293.2.523.269 1.052.468h.003c.255.136.405.266.478.399v-.131a.571.571 0 01.016.47c-.123.31-.516.643-1.063.842v.002c-.268.135-.501.333-.775.465-.276.135-.588.292-1.012.267a1.139 1.139 0 01-.448-.067 3.566 3.566 0 01-.322-.198c-.195-.135-.363-.332-.612-.465v-.005h-.005c-.4-.246-.616-.512-.686-.71-.07-.268-.005-.47.193-.6.224-.135.38-.271.483-.336.104-.074.143-.102.176-.131h.002v-.003c.169-.202.436-.47.839-.601.139-.036.294-.065.466-.065zm2.8 2.142c.358 1.417 1.196 3.475 1.735 4.473.286.534.855 1.659 1.102 3.024.156-.005.33.018.513.064.646-1.671-.546-3.467-1.089-3.966-.22-.2-.232-.335-.123-.335.59.534 1.365 1.572 1.646 2.757.13.535.16 1.104.021 1.67.067.028.135.06.205.067 1.032.534 1.413.938 1.23 1.537v-.043c-.06-.003-.12 0-.18 0h-.016c.151-.467-.182-.825-1.065-1.224-.915-.4-1.646-.336-1.77.465-.008.043-.013.066-.018.135-.068.023-.139.053-.209.064-.43.268-.662.669-.793 1.187-.13.533-.17 1.156-.205 1.869v.003c-.02.334-.17.838-.319 1.35-1.5 1.072-3.58 1.538-5.348.334a2.645 2.645 0 00-.402-.533 1.45 1.45 0 00-.275-.333c.182 0 .338-.03.465-.067a.615.615 0 00.314-.334c.108-.267 0-.697-.345-1.163-.345-.467-.931-.995-1.788-1.521-.63-.4-.986-.87-1.15-1.396-.165-.534-.143-1.085-.015-1.645.245-1.07.873-2.11 1.274-2.763.107-.065.037.135-.408.974-.396.751-1.14 2.497-.122 3.854a8.123 8.123 0 01.647-2.876c.564-1.278 1.743-3.504 1.836-5.268.048.036.217.135.289.202.218.133.38.333.59.465.21.201.477.335.876.335.039.003.075.006.11.006.412 0 .73-.134.997-.268.29-.134.52-.334.74-.4h.005c.467-.135.835-.402 1.044-.7zm2.185 8.958c.037.6.343 1.245.882 1.377.588.134 1.434-.333 1.791-.765l.211-.01c.315-.007.577.01.847.268l.003.003c.208.199.305.53.391.876.085.4.154.78.409 1.066.486.527.645.906.636 1.14l.003-.007v.018l-.003-.012c-.015.262-.185.396-.498.595-.63.401-1.746.712-2.457 1.57-.618.737-1.37 1.14-2.036 1.191-.664.053-1.237-.2-1.574-.898l-.005-.003c-.21-.4-.12-1.025.056-1.69.176-.668.428-1.344.463-1.897.037-.714.076-1.335.195-1.814.12-.465.308-.797.641-.984l.045-.022zm-10.814.049h.01c.053 0 .105.005.157.014.376.055.706.333 1.023.752l.91 1.664.003.003c.243.533.754 1.064 1.189 1.637.434.598.77 1.131.729 1.57v.006c-.057.744-.48 1.148-1.125 1.294-.645.135-1.52.002-2.395-.464-.968-.536-2.118-.469-2.857-.602-.369-.066-.61-.2-.723-.4-.11-.2-.113-.602.123-1.23v-.004l.002-.003c.117-.334.03-.752-.027-1.118-.055-.401-.083-.71.043-.94.16-.334.396-.4.69-.533.294-.135.64-.202.915-.47h.002v-.002c.256-.268.445-.601.668-.838.19-.201.38-.336.663-.336zm7.159-9.074c-.435.201-.945.535-1.488.535-.542 0-.97-.267-1.28-.466-.154-.134-.28-.268-.373-.335-.164-.134-.144-.333-.074-.333.109.016.129.134.199.2.096.066.215.2.36.333.292.2.68.467 1.167.467.485 0 1.053-.267 1.398-.466.195-.135.445-.334.648-.467.156-.136.149-.267.279-.267.128.016.034.134-.147.332a8.097 8.097 0 01-.69.468zm-1.082-1.583V5.64c-.006-.02.013-.042.029-.05.074-.043.18-.027.26.004.063 0 .16.067.15.135-.006.049-.085.066-.135.066-.055 0-.092-.043-.141-.068-.052-.018-.146-.008-.163-.065zm-.551 0c-.02.058-.113.049-.166.066-.047.025-.086.068-.14.068-.05 0-.13-.02-.136-.068-.01-.066.088-.133.15-.133.08-.031.184-.047.259-.005.019.009.036.03.03.05v.02h.003z" />
  </svg>
);

// Backend returns a short-lived signed URL for the latest installer of each platform
const downloadApp = async (query = "") => {
  try {
    const response = await fetch(`${API_BASE}/download/trackabo${query}`);
    if (!response.ok) throw new Error("Failed to generate download URL");
    const data = await response.json();
    window.location.href = data.url;
  } catch (error) {
    console.error("Download error:", error);
    alert("Unable to download Trackabo right now. Please try again later.");
  }
};

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Navbar scroll effect
    const navbar = document.getElementById('navbar');
    const handleScroll = () => {
      navbar.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);

    // Scroll-reveal
    const revealEls = document.querySelectorAll('.scroll-reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => io.observe(el));

    // Smooth scroll for anchor links
    const anchors = document.querySelectorAll('a[href^="#"]');
    const handleAnchorClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    };
    anchors.forEach(a => a.addEventListener('click', handleAnchorClick));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      anchors.forEach(a => a.removeEventListener('click', handleAnchorClick));
      io.disconnect();
    };
  }, []);

  return (
    <>
      <style>{`
        /* ============================================================
           DESIGN TOKENS
        ============================================================ */
        :root {
          --navy:       #1A1A40;
          --navy-light: #24245a;
          --cyan:       #00D2FF;
          --cyan-dim:   rgba(0, 210, 255, 0.15);
          --offwhite:   #F8F9FA;
          --white:      #FFFFFF;
          --text-dark:  #333333;
          --text-mid:   #6b7280;
          --text-light: #9ca3af;
          --border:     #e5e7eb;
        }

        /* ============================================================
           BASE — scoped to .trackabo-landing
        ============================================================ */
        .trackabo-landing * { box-sizing: border-box; }
        .trackabo-landing { font-family: 'Inter', sans-serif; overflow-x: hidden; }
        .trackabo-landing h1,
        .trackabo-landing h2,
        .trackabo-landing h3,
        .trackabo-landing h4 {
          font-weight: 700;
          letter-spacing: -0.02em;
          color: var(--navy);
        }
        .trackabo-landing p { color: var(--text-mid); line-height: 1.75; }
        .trackabo-landing a { text-decoration: none; }
        .trackabo-landing section { position: relative; }

        /* ============================================================
           NAVBAR
        ============================================================ */
        #navbar {
          background: transparent;
          transition: background 0.35s ease, box-shadow 0.35s ease;
          padding: 1rem 0;
          z-index: 1050;
        }
        #navbar.scrolled {
          background: rgba(26, 26, 64, 0.97);
          backdrop-filter: blur(8px);
          box-shadow: 0 2px 20px rgba(0,0,0,0.18);
        }
        .trackabo-landing .navbar-brand {
          font-size: 1.5rem;
          font-weight: 800;
          color: var(--white) !important;
          letter-spacing: -0.03em;
        }
        .trackabo-landing .navbar-brand span { color: var(--cyan); }
        .trackabo-landing .nav-link {
          color: rgba(255,255,255,0.82) !important;
          font-weight: 500;
          font-size: 0.92rem;
          padding: 0.4rem 0.9rem !important;
          transition: color 0.2s;
        }
        .trackabo-landing .nav-link:hover { color: var(--cyan) !important; }
        .trackabo-landing .btn-login {
          color: rgba(255,255,255,0.82);
          font-weight: 500;
          font-size: 0.92rem;
          padding: 0.4rem 1rem;
          border-radius: 6px;
          transition: color 0.2s;
          background: none;
          border: none;
          cursor: pointer;
        }
        .trackabo-landing .btn-login:hover { color: var(--cyan); }
        .trackabo-landing .btn-cyan {
          background: var(--cyan);
          color: var(--navy);
          font-weight: 700;
          font-size: 0.9rem;
          padding: 0.55rem 1.35rem;
          border-radius: 8px;
          border: none;
          transition: box-shadow 0.25s, transform 0.2s;
          white-space: nowrap;
          cursor: pointer;
          display: inline-block;
        }
        .trackabo-landing .btn-cyan:hover {
          box-shadow: 0 0 22px rgba(0, 210, 255, 0.5);
          transform: translateY(-1px);
          color: var(--navy);
        }
        .trackabo-landing .btn-outline-cyan {
          border: 2px solid var(--cyan);
          color: var(--cyan);
          font-weight: 600;
          font-size: 0.9rem;
          padding: 0.5rem 1.35rem;
          border-radius: 8px;
          background: transparent;
          transition: background 0.2s, color 0.2s;
          display: inline-block;
        }
        .trackabo-landing .btn-outline-cyan:hover {
          background: var(--cyan);
          color: var(--navy);
        }
        .trackabo-landing .navbar-toggler { border-color: rgba(255,255,255,0.3); }
        .trackabo-landing .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255,255,255,0.85%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
        }

        /* ============================================================
           HERO
        ============================================================ */
        #hero {
          min-height: 100vh;
          background: linear-gradient(135deg, var(--navy) 0%, #0d0d2b 60%, #0a1a3a 100%);
          display: flex;
          align-items: center;
          padding: 120px 0 80px;
          overflow: hidden;
        }
        #hero::before {
          content: '';
          position: absolute;
          top: -180px; right: -180px;
          width: 600px; height: 600px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,210,255,0.12) 0%, transparent 70%);
          pointer-events: none;
        }
        #hero::after {
          content: '';
          position: absolute;
          bottom: -100px; left: -100px;
          width: 400px; height: 400px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,210,255,0.07) 0%, transparent 70%);
          pointer-events: none;
        }
        .hero-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(0,210,255,0.12);
          border: 1px solid rgba(0,210,255,0.3);
          color: var(--cyan);
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          padding: 0.35rem 0.9rem;
          border-radius: 100px;
          margin-bottom: 1.4rem;
        }
        #hero h1 {
          font-size: clamp(2.2rem, 5vw, 3.6rem);
          font-weight: 900;
          line-height: 1.12;
          color: var(--white);
          letter-spacing: -0.04em;
          margin-bottom: 1.2rem;
        }
        #hero h1 .accent { color: var(--cyan); }
        #hero .hero-sub {
          font-size: 1.08rem;
          color: rgba(255,255,255,0.65);
          max-width: 480px;
          margin-bottom: 2.2rem;
          line-height: 1.75;
        }
        .hero-cta-group {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          align-items: center;
        }
        .hero-cta-group .btn-cyan {
          font-size: 1rem;
          padding: 0.75rem 1.8rem;
          border-radius: 10px;
        }
        .hero-cta-group .btn-outline-cyan {
          font-size: 1rem;
          padding: 0.7rem 1.6rem;
          border-radius: 10px;
        }
        .hero-trust {
          margin-top: 2.2rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-wrap: wrap;
        }
        .hero-trust .avatars { display: flex; }
        .hero-trust .avatars span {
          width: 32px; height: 32px;
          border-radius: 50%;
          border: 2px solid var(--navy);
          background: linear-gradient(135deg, var(--cyan), #007bff);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 0.65rem;
          font-weight: 700;
          color: var(--navy);
          margin-left: -8px;
        }
        .hero-trust .avatars span:first-child { margin-left: 0; }
        .hero-trust p { font-size: 0.82rem; color: rgba(255,255,255,0.5); margin: 0; }
        .hero-trust strong { color: rgba(255,255,255,0.85); }
        .hero-downloads {
          margin-top: 2rem;
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }
        .trackabo-landing .btn-download {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          min-width: 190px;
          padding: 0.6rem 1.3rem;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.18);
          background: rgba(255,255,255,0.06);
          color: #fff;
          font-weight: 700;
          font-size: 1rem;
          line-height: 1.15;
          text-align: left;
          cursor: pointer;
          transition: border-color 0.2s, background 0.2s, transform 0.2s;
        }
        .trackabo-landing .btn-download:hover {
          border-color: var(--cyan);
          background: rgba(0, 210, 255, 0.1);
          transform: translateY(-1px);
        }
        .trackabo-landing .btn-download svg { flex-shrink: 0; color: var(--cyan); }
        .trackabo-landing .btn-download small {
          display: block;
          font-size: 0.7rem;
          font-weight: 500;
          color: rgba(255,255,255,0.6);
        }

        /* Dashboard Mockup */
        .dashboard-mockup {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 30px 80px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.06);
          overflow: hidden;
        }
        .mockup-titlebar {
          background: #f0f2f5;
          padding: 0.65rem 1rem;
          display: flex;
          align-items: center;
          gap: 0.45rem;
          border-bottom: 1px solid #e5e7eb;
        }
        .mockup-dot { width: 10px; height: 10px; border-radius: 50%; }
        .mockup-dot.red   { background: #ff5f57; }
        .mockup-dot.yellow{ background: #febc2e; }
        .mockup-dot.green { background: #28c840; }
        .mockup-body { background: #f7f8fc; padding: 1.1rem; }
        .kpi-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0.65rem;
          margin-bottom: 0.9rem;
        }
        .kpi-card {
          background: #fff;
          border-radius: 10px;
          padding: 0.85rem 0.75rem;
          border: 1px solid #e9ecef;
        }
        .kpi-label { font-size: 0.62rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 0.3rem; }
        .kpi-value { font-size: 1.25rem; font-weight: 800; color: var(--navy); line-height: 1; }
        .kpi-delta { font-size: 0.6rem; color: #10b981; font-weight: 600; margin-top: 0.25rem; }
        .charts-row {
          display: grid;
          grid-template-columns: 1.6fr 1fr;
          gap: 0.65rem;
          margin-bottom: 0.9rem;
        }
        .chart-card { background: #fff; border-radius: 10px; padding: 0.85rem 0.75rem; border: 1px solid #e9ecef; }
        .chart-title { font-size: 0.68rem; font-weight: 700; color: var(--navy); margin-bottom: 0.7rem; }
        .bar-chart { display: flex; align-items: flex-end; gap: 5px; height: 70px; }
        .bar-wrap { display: flex; flex-direction: column; align-items: center; gap: 4px; flex: 1; }
        .bar { width: 100%; border-radius: 4px 4px 0 0; background: var(--cyan-dim); }
        .bar.active { background: var(--cyan); }
        .bar-label { font-size: 0.5rem; color: #9ca3af; font-weight: 600; }
        .donut-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 90px; }
        .donut {
          width: 70px; height: 70px;
          border-radius: 50%;
          background: conic-gradient(var(--cyan) 0% 73%, #e9ecef 73% 100%);
          display: flex; align-items: center; justify-content: center;
          position: relative;
        }
        .donut::before {
          content: '';
          width: 48px; height: 48px;
          background: #fff;
          border-radius: 50%;
          position: absolute;
        }
        .donut-text { position: relative; z-index: 1; font-size: 0.8rem; font-weight: 800; color: var(--navy); }
        .donut-label { font-size: 0.58rem; color: #9ca3af; margin-top: 0.4rem; font-weight: 600; }
        .activity-card { background: #fff; border-radius: 10px; padding: 0.8rem 0.75rem; border: 1px solid #e9ecef; }
        .activity-item { display: flex; align-items: center; gap: 0.6rem; padding: 0.35rem 0; border-bottom: 1px solid #f3f4f6; }
        .activity-item:last-child { border-bottom: none; }
        .activity-avatar {
          width: 24px; height: 24px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--cyan), #007bff);
          display: flex; align-items: center; justify-content: center;
          font-size: 0.5rem; font-weight: 700; color: var(--navy);
          flex-shrink: 0;
        }
        .activity-info { flex: 1; }
        .activity-name { font-size: 0.62rem; font-weight: 700; color: var(--navy); }
        .activity-task { font-size: 0.58rem; color: #9ca3af; }
        .activity-time { font-size: 0.55rem; color: #9ca3af; white-space: nowrap; }

        /* ============================================================
           FEATURES
        ============================================================ */
        #features { background: var(--offwhite); padding: 100px 0; }
        .section-eyebrow { font-size: 0.78rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--cyan); margin-bottom: 0.6rem; }
        .section-title { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: var(--navy); letter-spacing: -0.03em; line-height: 1.2; }
        .section-sub { font-size: 1rem; color: var(--text-mid); max-width: 520px; margin: 0 auto; }
        .feature-card { background: var(--white); border-radius: 16px; padding: 2.2rem 1.8rem; border: 1px solid var(--border); transition: transform 0.25s, box-shadow 0.25s; height: 100%; }
        .feature-card:hover { transform: translateY(-5px); box-shadow: 0 16px 48px rgba(0,0,0,0.08); }
        .feature-icon { width: 56px; height: 56px; border-radius: 14px; background: var(--cyan-dim); display: flex; align-items: center; justify-content: center; margin-bottom: 1.3rem; }
        .feature-icon i { font-size: 1.4rem; color: var(--cyan); }
        .feature-card h4 { font-size: 1.12rem; font-weight: 700; margin-bottom: 0.65rem; color: var(--navy); }
        .feature-card p { font-size: 0.92rem; color: var(--text-mid); margin: 0; line-height: 1.7; }

        /* ============================================================
           PRICING
        ============================================================ */
        #pricing { background: var(--white); padding: 100px 0; }
        .pricing-card { border-radius: 20px; padding: 2.5rem 2rem; border: 1.5px solid var(--border); height: 100%; position: relative; transition: transform 0.25s, box-shadow 0.25s; }
        .pricing-card:hover { transform: translateY(-4px); }
        .pricing-card.featured { border-color: var(--cyan); box-shadow: 0 0 0 1px var(--cyan), 0 20px 60px rgba(0,210,255,0.12); }
        .pricing-badge { position: absolute; top: -14px; left: 50%; transform: translateX(-50%); background: var(--cyan); color: var(--navy); font-size: 0.72rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; padding: 0.3rem 1rem; border-radius: 100px; white-space: nowrap; }
        .pricing-tier { font-size: 0.78rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--text-mid); margin-bottom: 0.5rem; }
        .pricing-tier.featured-tier { color: var(--cyan); }
        .pricing-price { font-size: 3rem; font-weight: 900; color: var(--navy); letter-spacing: -0.04em; line-height: 1; margin-bottom: 0.25rem; }
        .pricing-price span { font-size: 1.1rem; font-weight: 600; color: var(--text-mid); }
        .pricing-desc { font-size: 0.88rem; color: var(--text-mid); margin-bottom: 1.8rem; min-height: 2.5rem; }
        .pricing-divider { height: 1px; background: var(--border); margin-bottom: 1.5rem; }
        .pricing-feature { display: flex; align-items: flex-start; gap: 0.75rem; margin-bottom: 0.8rem; font-size: 0.9rem; color: var(--text-dark); }
        .pricing-feature .check { color: var(--cyan); font-weight: 700; flex-shrink: 0; margin-top: 1px; }
        .pricing-card .btn-cyan { width: 100%; text-align: center; font-size: 0.95rem; padding: 0.75rem; border-radius: 10px; margin-top: 1.5rem; display: block; }
        .pricing-card .btn-outline-navy { width: 100%; border: 2px solid var(--border); color: var(--navy); font-weight: 600; font-size: 0.95rem; padding: 0.7rem; border-radius: 10px; background: transparent; margin-top: 1.5rem; transition: border-color 0.2s, background 0.2s; display: block; text-align: center; }
        .pricing-card .btn-outline-navy:hover { border-color: var(--navy); background: var(--navy); color: var(--white); }

        /* ============================================================
           TESTIMONIALS
        ============================================================ */
        #testimonials { background: var(--offwhite); padding: 100px 0; }
        .testi-card { background: var(--white); border-radius: 16px; padding: 2rem 1.8rem; border: 1px solid var(--border); height: 100%; transition: transform 0.25s, box-shadow 0.25s; }
        .testi-card:hover { transform: translateY(-4px); box-shadow: 0 14px 40px rgba(0,0,0,0.07); }
        .stars { color: #f59e0b; font-size: 0.85rem; letter-spacing: 0.05em; margin-bottom: 1rem; }
        .testi-quote { font-size: 0.95rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.5rem; font-style: italic; }
        .testi-author { display: flex; align-items: center; gap: 0.9rem; }
        .testi-avatar { width: 44px; height: 44px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 1rem; color: var(--navy); flex-shrink: 0; }
        .testi-name { font-size: 0.9rem; font-weight: 700; color: var(--navy); margin: 0; }
        .testi-role { font-size: 0.78rem; color: var(--text-mid); margin: 0; }

        /* ============================================================
           STATS STRIP
        ============================================================ */
        .stats-strip { background: var(--navy); padding: 2.5rem 0; }
        .stat-item { text-align: center; padding: 0.5rem; }
        .stat-number { font-size: 2.2rem; font-weight: 900; color: var(--white); letter-spacing: -0.04em; line-height: 1; }
        .stat-number span { color: var(--cyan); }
        .stat-label { font-size: 0.8rem; color: rgba(255,255,255,0.5); font-weight: 500; margin-top: 0.3rem; }

        /* ============================================================
           FOOTER
        ============================================================ */
        #trackabo-footer { background: var(--navy); padding: 70px 0 30px; }
        .footer-logo { font-size: 1.4rem; font-weight: 800; color: var(--white); letter-spacing: -0.03em; margin-bottom: 0.75rem; }
        .footer-logo span { color: var(--cyan); }
        .footer-tagline { font-size: 0.85rem; color: rgba(255,255,255,0.45); max-width: 220px; line-height: 1.65; }
        .footer-heading { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: rgba(255,255,255,0.4); margin-bottom: 1.1rem; }
        .footer-links { list-style: none; padding: 0; margin: 0; }
        .footer-links li { margin-bottom: 0.6rem; }
        .footer-links a { color: rgba(255,255,255,0.65); font-size: 0.88rem; transition: color 0.2s; }
        .footer-links a:hover { color: var(--cyan); }
        .footer-divider { height: 1px; background: rgba(255,255,255,0.08); margin: 2.5rem 0 1.5rem; }
        .footer-bottom { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; }
        .footer-copy { font-size: 0.8rem; color: rgba(255,255,255,0.35); margin: 0; }
        .social-links { display: flex; gap: 0.75rem; }
        .social-links a { width: 36px; height: 36px; border-radius: 8px; background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.55); font-size: 0.85rem; transition: background 0.2s, color 0.2s; }
        .social-links a:hover { background: var(--cyan); color: var(--navy); border-color: var(--cyan); }

        /* ============================================================
           SCROLL REVEAL
        ============================================================ */
        .scroll-reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.55s ease, transform 0.55s ease; }
        .scroll-reveal.visible { opacity: 1; transform: translateY(0); }
        .delay-1 { transition-delay: 0.1s; }
        .delay-2 { transition-delay: 0.2s; }
        .delay-3 { transition-delay: 0.3s; }
        .delay-4 { transition-delay: 0.4s; }

        /* ============================================================
           RESPONSIVE
        ============================================================ */
        @media (max-width: 767.98px) {
          #hero { padding: 110px 0 60px; text-align: center; }
          #hero .hero-sub { margin-left: auto; margin-right: auto; }
          .hero-cta-group { justify-content: center; }
          .hero-trust { justify-content: center; }
          .hero-downloads { justify-content: center; }
          .dashboard-mockup { margin-top: 2.5rem; }
          .charts-row { grid-template-columns: 1fr; }
        }
        @media (max-width: 575.98px) {
          .kpi-row { gap: 0.4rem; }
          .kpi-value { font-size: 1rem; }
          .pricing-card { padding: 2rem 1.5rem; }
        }
      `}</style>

      <div className="trackabo-landing">

        {/* ── NAVBAR ── */}
        <nav id="navbar" className="navbar navbar-expand-lg fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Track<span>abo</span></a>
            <button className="navbar-toggler" type="button"
              data-bs-toggle="collapse" data-bs-target="#navMenu"
              aria-controls="navMenu" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navMenu">
              <ul className="navbar-nav mx-auto gap-lg-1">
                <li className="nav-item"><a className="nav-link" href="#features">Features</a></li>
                <li className="nav-item"><a className="nav-link" href="#pricing">Pricing</a></li>
                <li className="nav-item"><a className="nav-link" href="#testimonials">Testimonials</a></li>
              </ul>
              <div className="d-flex align-items-center gap-2 mt-3 mt-lg-0">
                <button className="btn-login d-none d-lg-inline" onClick={() => navigate('/authentication/sign-in')}>
                  Log In
                </button>
                <button className="btn-cyan" onClick={() => navigate('/authentication/sign-up')}>
                  Start Free Trial
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* ── HERO ── */}
        <section id="hero">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-md-6">
                <div className="hero-eyebrow">
                  <i className="fa-solid fa-bolt"></i> New — AI-powered summaries
                </div>
                <h1>
                  Master Your<br />Workday,<br />
                  <span className="accent">Effortlessly.</span>
                </h1>
                <p className="hero-sub">
                  Automated time tracking, real-time analytics, and team oversight
                  in one sleek dashboard. Stop guessing where your hours go.
                </p>
                <div className="hero-cta-group">
                  <button className="btn-cyan" onClick={() => navigate('/authentication/sign-up')}>
                    Start Free Trial
                  </button>
                  <a href="#features" className="btn-outline-cyan">
                    <i className="fa-solid fa-circle-play"></i> Watch Demo
                  </a>
                </div>
                <div className="hero-trust">
                  <div className="avatars">
                    <span>JR</span><span>SK</span><span>AM</span><span>TC</span>
                  </div>
                  <p><strong>4,200+ teams</strong> track smarter with Trackabo</p>
                </div>
                <div className="hero-downloads">
                  <button type="button" className="btn-download" onClick={() => downloadApp()}>
                    <WindowsIcon />
                    <span>
                      <small>Download for</small>
                      Windows
                    </span>
                  </button>
                  <button type="button" className="btn-download" onClick={() => downloadApp("?os=linux&format=deb")}>
                    <LinuxIcon />
                    <span>
                      <small>Download for</small>
                      Linux (.deb)
                    </span>
                  </button>
                </div>
              </div>

              <div className="col-md-6">
                <div className="dashboard-mockup scroll-reveal">
                  <div className="mockup-titlebar">
                    <div className="mockup-dot red"></div>
                    <div className="mockup-dot yellow"></div>
                    <div className="mockup-dot green"></div>
                    <span style={{fontSize:'0.65rem',color:'#9ca3af',marginLeft:'0.5rem',fontWeight:600}}>Trackabo Dashboard</span>
                  </div>
                  <div className="mockup-body">
                    <div className="kpi-row">
                      <div className="kpi-card">
                        <div className="kpi-label">Hours Today</div>
                        <div className="kpi-value">6.4h</div>
                        <div className="kpi-delta">↑ 12% vs yesterday</div>
                      </div>
                      <div className="kpi-card">
                        <div className="kpi-label">Active Tasks</div>
                        <div className="kpi-value">14</div>
                        <div className="kpi-delta">↑ 3 new today</div>
                      </div>
                      <div className="kpi-card">
                        <div className="kpi-label">Team Online</div>
                        <div className="kpi-value">9/12</div>
                        <div className="kpi-delta">75% capacity</div>
                      </div>
                    </div>
                    <div className="charts-row">
                      <div className="chart-card">
                        <div className="chart-title">Weekly Hours</div>
                        <div className="bar-chart">
                          {[{h:42,l:'Mon'},{h:55,l:'Tue'},{h:62,l:'Wed',active:true},{h:48,l:'Thu'},{h:38,l:'Fri'},{h:20,l:'Sat'},{h:10,l:'Sun'}].map(({h,l,active}) => (
                            <div key={l} className="bar-wrap">
                              <div className={`bar${active?' active':''}`} style={{height:`${h}px`}}></div>
                              <div className="bar-label">{l}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="chart-card">
                        <div className="chart-title">Goal Progress</div>
                        <div className="donut-wrap">
                          <div className="donut"><div className="donut-text">73%</div></div>
                          <div className="donut-label">Weekly target</div>
                        </div>
                      </div>
                    </div>
                    <div className="activity-card">
                      <div className="chart-title" style={{marginBottom:'0.5rem'}}>Recent Activity</div>
                      {[
                        {init:'JR',name:'James R.',task:'Completed UI review — 2h 15m',time:'2m ago',bg:''},
                        {init:'SK',name:'Sara K.',task:'Started Sprint Planning — 0h 42m',time:'18m ago',bg:'linear-gradient(135deg,#a78bfa,#7c3aed)'},
                        {init:'AM',name:'Alex M.',task:'Closed 3 tickets — 1h 05m',time:'34m ago',bg:'linear-gradient(135deg,#fb923c,#ef4444)'},
                      ].map(({init,name,task,time,bg}) => (
                        <div key={init} className="activity-item">
                          <div className="activity-avatar" style={bg?{background:bg}:{}}>{init}</div>
                          <div className="activity-info">
                            <div className="activity-name">{name}</div>
                            <div className="activity-task">{task}</div>
                          </div>
                          <div className="activity-time">{time}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── STATS STRIP ── */}
        <div className="stats-strip">
          <div className="container">
            <div className="row g-0 text-center">
              {[
                {n:'4.2',s:'K+',l:'Teams worldwide'},
                {n:'98',s:'%',l:'Customer satisfaction'},
                {n:'2.1',s:'M',l:'Hours tracked daily'},
                {n:'99.9',s:'%',l:'Uptime SLA'},
              ].map(({n,s,l},i) => (
                <div key={l} className={`col-6 col-md-3 stat-item scroll-reveal${i>0?` delay-${i}`:''}`}>
                  <div className="stat-number">{n}<span>{s}</span></div>
                  <div className="stat-label">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── FEATURES ── */}
        <section id="features">
          <div className="container">
            <div className="text-center mb-5">
              <div className="section-eyebrow">Why Trackabo</div>
              <h2 className="section-title mb-3">Built for teams who move fast</h2>
              <p className="section-sub">Every feature is designed to reduce admin overhead and surface insights your team can actually act on.</p>
            </div>
            <div className="row g-4">
              {[
                {icon:'fa-clock',title:'Smart Time Tracking',desc:'Automatic detection of active work sessions means you never forget to log time. Background tracking that respects privacy and stays out of your way.'},
                {icon:'fa-chart-line',title:'Deep Analytics',desc:'Real-time dashboards that break down productivity by project, person, and time period. Export any report to PDF or CSV in one click.',delay:'delay-1'},
                {icon:'fa-shield-alt',title:'Enterprise Security',desc:'SOC 2 Type II certified. SSO, role-based access, audit logs, and data residency controls. Security that scales from startup to enterprise without friction.',delay:'delay-2'},
                {icon:'fa-users',title:'Team Oversight',desc:"See who's working on what, in real time. Capacity heatmaps help managers balance workloads before deadlines slip.",delay:'delay-1'},
                {icon:'fa-plug',title:'100+ Integrations',desc:'Sync with Jira, Asana, Slack, GitHub, and your billing tools. Trackabo fits your existing stack — not the other way around.',delay:'delay-2'},
                {icon:'fa-bolt',title:'AI Summaries',desc:'Weekly digests that highlight anomalies, celebrate wins, and flag at-risk projects — written in plain language, ready to share with stakeholders.',delay:'delay-3'},
              ].map(({icon,title,desc,delay=''}) => (
                <div key={title} className={`col-md-4 scroll-reveal ${delay}`}>
                  <div className="feature-card">
                    <div className="feature-icon"><i className={`fa-solid ${icon}`}></i></div>
                    <h4>{title}</h4>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PRICING ── */}
        <section id="pricing">
          <div className="container">
            <div className="text-center mb-5">
              <div className="section-eyebrow">Pricing</div>
              <h2 className="section-title mb-3">Simple, transparent pricing</h2>
              <p className="section-sub">Start free, scale when you're ready. No hidden fees, no annual commitment required.</p>
            </div>
            <div className="row g-4 justify-content-center">
              <div className="col-md-4 scroll-reveal">
                <div className="pricing-card">
                  <div className="pricing-tier">Free</div>
                  <div className="pricing-price">$0 <span>/ mo</span></div>
                  <p className="pricing-desc">Perfect for individuals and small teams getting started.</p>
                  <div className="pricing-divider"></div>
                  {['Up to 3 users','5 active projects','Basic time tracking','7-day data history','CSV export'].map(f => (
                    <div key={f} className="pricing-feature"><span className="check">✓</span> {f}</div>
                  ))}
                  <button className="btn-outline-navy" onClick={() => navigate('/authentication/sign-up')}>Get Started Free</button>
                </div>
              </div>
              <div className="col-md-4 scroll-reveal delay-1">
                <div className="pricing-card featured">
                  <div className="pricing-badge">Most Popular</div>
                  <div className="pricing-tier featured-tier">Pro</div>
                  <div className="pricing-price">$18 <span>/ mo per user</span></div>
                  <p className="pricing-desc">Everything a growing team needs to stay on track.</p>
                  <div className="pricing-divider"></div>
                  {['Unlimited users','Unlimited projects','AI-powered summaries','Real-time analytics','100+ integrations','Priority support'].map(f => (
                    <div key={f} className="pricing-feature"><span className="check">✓</span> {f}</div>
                  ))}
                  <button className="btn-cyan" onClick={() => navigate('/authentication/sign-up')}>Start Free Trial</button>
                </div>
              </div>
              <div className="col-md-4 scroll-reveal delay-2">
                <div className="pricing-card">
                  <div className="pricing-tier">Enterprise</div>
                  <div className="pricing-price" style={{fontSize:'2.2rem'}}>Custom</div>
                  <p className="pricing-desc">For large organisations with custom compliance and security needs.</p>
                  <div className="pricing-divider"></div>
                  {['Everything in Pro','SSO & SAML','SOC 2 Type II','Data residency controls','Dedicated success manager','SLA guarantee'].map(f => (
                    <div key={f} className="pricing-feature"><span className="check">✓</span> {f}</div>
                  ))}
                  <button className="btn-outline-navy" onClick={() => navigate('/contact')}>Contact Sales</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── TESTIMONIALS ── */}
        <section id="testimonials">
          <div className="container">
            <div className="text-center mb-5">
              <div className="section-eyebrow">Testimonials</div>
              <h2 className="section-title mb-3">Trusted by teams who ship</h2>
              <p className="section-sub">Real feedback from real teams using Trackabo every day.</p>
            </div>
            <div className="row g-4">
              {[
                {init:'LM',quote:'We cut billing disputes by 80% in the first month. Clients trust our invoices now because every minute is backed by data.',name:'Laura Mitchell',role:'CEO, Apexio Studio',bg:'linear-gradient(135deg,#00D2FF,#007bff)'},
                {init:'DK',quote:'The AI summary emails my manager loves are actually generated from Trackabo data. Setup took 20 minutes and it just works.',name:'Dev Kapoor',role:'Engineering Lead, Nuvelo',bg:'linear-gradient(135deg,#a78bfa,#7c3aed)',delay:'delay-1'},
                {init:'SR',quote:'Onboarding 40 remote employees used to be chaotic. Trackabo gave us visibility across time zones without micromanaging anyone.',name:'Sofia Reyes',role:'Head of Ops, Crestline HR',bg:'linear-gradient(135deg,#fb923c,#ef4444)',delay:'delay-2'},
              ].map(({init,quote,name,role,bg,delay=''}) => (
                <div key={init} className={`col-md-4 scroll-reveal ${delay}`}>
                  <div className="testi-card">
                    <div className="stars">★★★★★</div>
                    <p className="testi-quote">"{quote}"</p>
                    <div className="testi-author">
                      <div className="testi-avatar" style={{background:bg}}>{init}</div>
                      <div>
                        <p className="testi-name">{name}</p>
                        <p className="testi-role">{role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── FOOTER ── */}
        <footer id="trackabo-footer">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4 col-lg-3">
                <div className="footer-logo">Track<span>abo</span></div>
                <p className="footer-tagline">Time tracking and analytics for teams who take their work seriously.</p>
              </div>
              <div className="col-6 col-md-2">
                <div className="footer-heading">Product</div>
                <ul className="footer-links">
                  {['Features','Integrations','Changelog','Roadmap','API Docs'].map(l => <li key={l}><a href="#">{l}</a></li>)}
                </ul>
              </div>
              <div className="col-6 col-md-2">
                <div className="footer-heading">Company</div>
                <ul className="footer-links">
                  {['About','Blog','Careers','Press Kit','Contact'].map(l => <li key={l}><a href="#">{l}</a></li>)}
                </ul>
              </div>
              <div className="col-6 col-md-2">
                <div className="footer-heading">Legal</div>
                <ul className="footer-links">
                  {['Privacy Policy','Terms of Service','Cookie Policy','Security','GDPR'].map(l => <li key={l}><a href="#">{l}</a></li>)}
                </ul>
              </div>
              <div className="col-6 col-md-2">
                <div className="footer-heading">Follow Us</div>
                <div className="social-links flex-wrap" style={{gap:'0.5rem'}}>
                  <a href="#" aria-label="Twitter"><i className="fa-brands fa-x-twitter"></i></a>
                  <a href="#" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
                  <a href="#" aria-label="GitHub"><i className="fa-brands fa-github"></i></a>
                  <a href="#" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
                </div>
              </div>
            </div>
            <div className="footer-divider"></div>
            <div className="footer-bottom">
              <p className="footer-copy">© 2025 Trackabo Inc. All rights reserved.</p>
              <div className="social-links d-none d-md-flex">
                <a href="#" style={{fontSize:'0.7rem',width:'auto',padding:'0 0.6rem',gap:'0.35rem'}} aria-label="Status">
                  <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#10b981',display:'inline-block'}}></span>
                  All systems operational
                </a>
              </div>
            </div>
          </div>
        </footer>

      </div>
    </>
  );
};

export default Home;